import i18next from "i18next";
import Colors, { quillColors } from "./colors";
export default class FederationTemplateConfig {
    constructor() {
        this.colors = Colors;
        this.quillColors = quillColors;
    }
    get language() {
        return i18next.language;
    }
    get isFinlandEquestrian() {
        return this.countryCode == "FI";
    }
    get isNorwayEquestrian() {
        return this.countryCode == "NO";
    }
    get isUkraineEquestrian() {
        return this.countryCode == "UA";
    }
    get isBelgiumEquestrian() {
        return this.countryCode == "BE";
    }
    get isNetherlandsEquestrian() {
        return this.countryCode == "NL";
    }
}
